var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ueditor_box"},[_c('ueditor-wrap',{attrs:{"destroy":true,"config":_vm.ueditorConfig},on:{"ready":_vm.ready},model:{value:(_vm.curContent),callback:function ($$v) {_vm.curContent=$$v},expression:"curContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }